import React from 'react';
import styled from '@emotion/styled';
import { ShopType } from '../../../../types/shop';
import { VideoDefault } from '../../../../assets';

interface ColumnProps {
  record: ShopType;
}

export default React.memo((props: ColumnProps) => {
  const { record } = props;
  let imageLink = null;
  if (record.imageLink) {
    imageLink = `url('${record.imageLink}')`;
  } else if (record.videoLink) {
    imageLink = `url('${VideoDefault}')`;
  }

  return (
    <StyledProductContainer>
      {imageLink ? <div className="image" style={{ backgroundImage: imageLink }} /> : <div className="image" />}
    </StyledProductContainer>
  );
});

const StyledProductContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.5rem;
  .image {
    width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left !important;

  .ant-typography {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
